// src/hooks/useCleanupQueryParams.ts
import { useEffect } from "react";

export function useCleanupQueryParams(paramKeys: string[]) {
    useEffect(() => {
        const url = new URL(window.location.href);
        let changed = false;

        paramKeys.forEach((key) => {
            if (url.searchParams.has(key)) {
                url.searchParams.delete(key);
                changed = true;
            }
        });

        if (changed) {
            const newUrl = url.pathname + url.search;
            window.history.replaceState({}, document.title, newUrl);
        }
    }, [paramKeys]);
}
